import { useState } from 'react'

import { getAssetUrl } from '~/lib/assetUrlCache'
import getPlaceholderImage from '~/lib/getPlaceholderImage'

type ImagePropsType = {
    src?: string | null
    fallback?: string
    style?: { [key: string]: any }
    className?: string
    width?: string | number
    height?: string | number
    alt?: string
}

export default function Image(props: ImagePropsType) {
    const {
        fallback = getPlaceholderImage(null, true),
        src,
        ...newProps
    } = props
    const [error, setError] = useState<boolean>(false)

    const onError = () => setError(true)

    if (!src || error) {
        return <img src={fallback} {...newProps} />
    }

    return <img onError={onError} src={getAssetUrl(src)} {...newProps} />
}
